<template>
  <div>
    <v-file-input
      accept="image/png, image/jpeg, image/bmp"
      outlined
      prepend-icon=""
      :label="label"
      prepend-inner-icon="mdi-camera"
      placeholder="Imagen"
      v-model="newImage"
      @change="changeImgPresentation"
    ></v-file-input>
    <v-col cols="12">
      <v-img
        v-if="existeImagen"
        :src="urlImagen"
        :key="urlImagen"
        height="225"
        class="grey darken-4"
      ></v-img>
      <v-img v-else-if="image_default" :src="image_default" height="225">
      </v-img>
    </v-col>
  </div>
</template>

<script>
export default {
  props: {
    image_default: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: "Imagen"
    }
  },
  data() {
    return {
      loading: false,
      innerLoading: false,
      newImage: [],
      existeImagen: false,
      urlImagen: URL
    };
  },
  methods: {
    changeImgPresentation(e) {
      if (e) {
        this.existeImagen = true;
        const data = URL.createObjectURL(e).toString();
        this.urlImagen = data;
        // Suponiendo que 'event' es un objeto File, esto debería funcionar como se espera.
        this.$emit("changeImage", this.newImage);
      } else {
        URL.revokeObjectURL(this.urlImagen);
        this.existeImagen = false;
        this.urlImagen = "";
      }
    }
  }
};
</script>
